import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import Tabs from "../../components/Tabs";
import AvatarHome from "../../components/AvatarHome";
import ModalAlertnNews from "../../components/ModalAlertnNews";
import { setBuyPlans } from "../../store/slices/generics.slice";
import HomeStudentStudyAI from "../../components/HomeStudentStudyAI";
import ModalQuestionnaires from "../../components/ModalQuestionnaires";
import ModalSchedule from "../../components/ScheduleModals/ModalSchedule";
import HomeStudentScheduling from "../../components/HomeStudentScheduling";
import ModalBeAffiliated from "../../components/affiliates/ModalBeAffiliated";
import HomeStudentPlanCancelled from "../../components/HomeStudentPlanCancelled";
import HomeStudentDetailtContent from "../../components/HomeStudentDetailtContent";
import { getPendingQuestionnaires, getStudentPlansUser } from "../../store/middleware";

const options = ["MODULE", "MY_CONTENT", "AI_PRACTICE"];

function HomeStudent() {
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state.userReducer);
  const { plans } = useSelector((state) => state.studentReducer);

  const [loading, setLoading] = useState(true);
  const [activeTab, setActiveTab] = useState("MODULE");
  const [openSchedule, setOpenSchedule] = useState(false);
  const [openModalAlertNews, setOpenModalAlertNews] = useState(false);
  const [openModalQuestionnaires, setOpenModalQuestionnaires] = useState(false);

  let canceledPlans = [];
  canceledPlans = plans?.filter(
    (plan) =>
      plan.studentPlanPayments &&
      plan.studentPlanPayments.length > 0 &&
      plan.studentPlanPayments[0].status === "cancelled",
  );

  const customLang = plans && plans[0]?.studentPlanLanguages[0]?.lingoLanguage.customLang;

  const handleCloseSchedule = () => setOpenSchedule(false);

  const handleOpenSchedule = async () => {
    if (!customLang) return setOpenSchedule(true);

    const response = await dispatch(getPendingQuestionnaires());
    if (response?.filter((item) => !item.answered).length > 0) setOpenModalQuestionnaires(true);
    else setOpenSchedule(true);
  };

  const getData = async () => {
    await dispatch(setBuyPlans([]));
    await dispatch(getStudentPlansUser(user?.id));
    setLoading(false);

    console.log(user?.notifyControl);
    if (user?.notifyControl === "google") setOpenModalAlertNews(true);
  };

  useEffect(() => {
    getData();
    // eslint-disable-next-line
  }, []);

  if (loading) return null;

  if (plans?.length > 0 && plans?.length !== canceledPlans?.length) {
    return (
      <div className="student">
        <AvatarHome />

        <Tabs options={options} activeTab={activeTab} setActiveTab={setActiveTab}>
          {options[0] === activeTab && <HomeStudentScheduling openSchedule={handleOpenSchedule} />}
          {options[1] === activeTab && <HomeStudentDetailtContent setActiveTab={setActiveTab} />}
          {options[2] === activeTab && <HomeStudentStudyAI />}
        </Tabs>

        <ModalBeAffiliated />
        {openSchedule && <ModalSchedule openSchedule={openSchedule} closeSchedule={handleCloseSchedule} />}
        {openModalAlertNews && <ModalAlertnNews showModal={openModalAlertNews} setShowModal={setOpenModalAlertNews} />}
        {openModalQuestionnaires && (
          <ModalQuestionnaires showModal={openModalQuestionnaires} setShowModal={setOpenModalQuestionnaires} />
        )}
      </div>
    );
  }

  return (
    <div className="student">
      <AvatarHome />
      <HomeStudentPlanCancelled />
    </div>
  );
}

export default HomeStudent;
